import React, { Component, Fragment, createRef } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Checkbox, message, Popconfirm, Input, Modal, Row, Col, Tooltip, Typography } from 'antd';
import CpEmpty from '../../../components/CpEmpty';
import { inventoryCartList, inventoryDeleteList, inventoryUpdateList, inventorySuppliers, inventoryOrderTimeCategories, inventoryBrandList, inventoryCategoryList, inventoryClearList, inventoryCartListClearNumber } from '../api';
import { companyTree } from '../../erpList/api';
import CpLoading from '../../../components/CpLoading';
import { PurchaseCartProduct } from './purchaseCartProduct';
import { formateTree, treeToArray, amountStrToNumber, downLoad } from '../../../util/tool';
import { currency } from '../../quotationProduct/formatNumber';
import { QuestionCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { accAdd } from '../../../util/math';
import { ROOT_PATH } from '../../../origin';
import moment from 'moment';
// import CpSearchBar from '../../components/CpSearchBar';
// import CpLogo from '../../components/CpLogo';
// import { Index as CartForm } from './components/cartForm';
import './../style.less';

const arrival_type_config = {
  '1': '',// 次日达
  '2': '隔日达',
};

const { history } = window;
function calcNumber(record = {}) {
  // const { number, out_prop, out_norms_prop } = record;
  // const a = number / out_prop;
  // const b = Math.ceil(a / out_norms_prop) * out_norms_prop;
  // const c = (b * out_prop).toFixed(3);
  // return c;
  return `${record.number}`;
}

function calcOutNormsUnit(record = {}) {
  // const { number, out_prop, out_norms_prop, sale_unit, out_norms_unit, warehouse_type } = record;
  const { number, out_prop, out_norms_prop, out_norms_unit } = record;
  // const calc_norm = `(${(out_norms_prop * out_prop).toFixed(3)}${sale_unit}/${out_norms_unit})`;
  // const calc_norm = `(包规:${(out_norms_prop * out_prop).toFixed(3)}${out_norms_unit})`;
  // const calc_num = `${Math.ceil((number / out_prop) / out_norms_prop).toFixed(3)}${out_norms_unit}`;
  const out_norms_prop_out_prop = Number(out_norms_prop * out_prop);
  const calc_norm = `(包规:${(out_norms_prop_out_prop).toFixed(3)}${out_norms_unit})`;
  const calc_num = `${(Math.ceil((number / out_prop) / out_norms_prop) * out_norms_prop_out_prop).toFixed(3)}${out_norms_unit}`;
  // return warehouse_type === 'PCS' ? <><div>{calc_num}</div><div>{calc_norm}</div></> : <>{number}{sale_unit}</>;
  return <><div>{calc_num}</div><div>{calc_norm}</div></>;
}
function calcItemPrice(record = {}) {
  // const { number, norms_price, warehouse_type } = record;
  const { norms_price } = record;
  // return warehouse_type === 'PCS' ? currency(calcNumber(record) * norms_price) : currency(Number(number).toFixed(3));
  return currency(calcNumber(record) * norms_price);
}


function string2decimal(string_number = '') {
  let formateNumber = ('' + string_number).replace(/[^\d|^.|-]/g, '');
  formateNumber = formateNumber.includes('-') ? formateNumber = '-' + formateNumber.replace(/-/ig, '') : formateNumber;
  return formateNumber ? parseFloat(formateNumber) : 0;
}
function validateMinCount(selectProductInfo, keys) {
  const invalidList = [];
  for (const key of keys) {
    const { selectedRows = [] } = selectProductInfo[key] || {};
    for (const s of selectedRows) {
      const { min_count = 0, out_prop = 1, number = 0, out_sku_no = '', sale_name = '', sale_unit = '', out_unit = '' } = s;
      if (+min_count > 1) {
        const orderOutQty = (+number) * (+out_prop);
        if (orderOutQty < +min_count) {
          invalidList.push(`${out_sku_no}-${sale_name}-订货数量:${+number}${sale_unit}不能小于起订量:${+min_count}${out_unit}`);
        }
      }
    }
  }
  return invalidList;
}
const columns = [
  { title: '全选', key: 'select', align: 'left', width: 88 },
  { title: '商品信息', key: 'sale_name', width: 300, align: 'center', },
  // { title: '规格', key: 'unit_packing', width: 180, align: 'center', },
  // { title: '参考规格', key: 'reference_unit_packing', width: 180, align: 'center', },
  // { title: 'SKU商品编码', key: 'sku_no', width: 120, align: 'center', },
  // { title: 'RMS订货包规', key: 'out_norms_unit', width: 140, align: 'center', },
  // { title: '价格(元)', key: 'norms_price', width: 100, align: 'center', },
  // { title: 'RMS商品编码', key: 'out_sku_no', width: 120, align: 'center', },
  // { title: 'SKU商品单位', key: 'sale_unit', width: 140, align: 'center', },
  { title: '建议补货量', key: 'proposal_number', width: 150, align: 'center', },
  { title: '门店库存数', key: 'stock', width: 150, align: 'center', },
  { title: '最新售价', key: 'latest_sale_cost', width: 150, align: 'center', },
  { title: '最新成本', key: 'latest_cost', width: 150, align: 'center', },
  { title: '昨日销量', key: 'yesterday_sale_number', width: 150, align: 'center', },
  { title: '昨日订货量', key: 'yesterday_purchase_number', width: 150, align: 'center', },
  { title: '数量', key: 'number', width: 110, align: 'center', },
  // { title: '到货类型', key: 'arrival_type', width: 110, align: 'center', },
  // { title: '实际数量', key: 'real_number', width: 120, align: 'center', },
  // { title: '实际订货数量', key: 'out_norms_unit', width: 140, align: 'center', },
  // { title: '小计', key: 'item_price', width: 120, align: 'center', },
  // { title: '操作', key: 'operation', width: 40, align: 'center' },
];
class ProposalCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectProducts: {}, // 记录选中的商品
      suppliers: {},   // 记录各个供应商的商品和选中商品数
      selectedAll: false, // 全选按钮
      totalPrice: 0,
      totalCount: 0,
      emptyStatus: 'purchaseOrder',
      loading: true,
      currentProduct: {},
      erpMap: {},
      pre_sale_goods_id: '',
      order_no: '',
      ids: [],
      plan: {},
      addressId: '',
      list: [],
      selectProductInfo: JSON.parse(localStorage.getItem('select_rows_cache')) || {},
      number: undefined,
      currentId: undefined,
      tree: [],
      originTree: [],
      suppliersList: [],
      categories: [],
      brandList: [],
      categoryList: [],
      productModalVisible: false,
      can_check_all: false,
      all_price: 0,
      token: localStorage.getItem('token'),
      confirmRepeatProducts: false,
      todayProducts: {},
      confirmProductList: [],
      invalidOrderVisible: false,
      invalidOrderList: []
    };
    this.formRef = createRef();
  }
  init = async () => {
    try {
      let { selectProductInfo = {} } = this.state;
      const keys = Reflect.ownKeys(selectProductInfo);
      const formValues = this.formRef?.form?.getFieldsValue?.() || {};
      const { data: { data = {}, error, code } } = await inventoryCartList({ ...formValues, type: 1 });
      if (+code === 0) {
        const { list = [], today_sales = {} } = data;
        for (let item of list) {
          const { supplier_id, supplier_name } = item;
          for (const subItem of item.sale_list) {
            subItem.number = +subItem.number;
          }
          if (keys.length) {
            const { selectedRowKeys = [] } = selectProductInfo[supplier_id] || { selectedRowKeys: [], selectedRows: [] };
            const currentItem = list.find(item => String(item.supplier_id) === String(supplier_id));
            const selectedRows = currentItem?.sale_list.filter(c => selectedRowKeys.includes(c.id)).filter(item => item.can_check && (+item.number !== 0));
            const newSelectedRowKeys = selectedRows.map(item => item.id);
            selectProductInfo[supplier_id] = { ...selectProductInfo[supplier_id], selectedRows, selectedRowKeys: newSelectedRowKeys };
          } else {
            selectProductInfo[supplier_id] = { selectedRowKeys: [], selectedRows: [], checked: false, supplier_id, supplier_name };
          }
        }
        this.setState({ list, selectProductInfo, todayProducts: today_sales, loading: false }, this.computeTotal);
        this.selectRowsCache(selectProductInfo);
      } else {
        message.error(error, .5, history.back());
      }
    } catch (error) {
      this.setState({ loading: false });
    }
  }
  async componentDidMount() {
    this.init();
    Promise.all([this.getSuppliers(), this.getSuppliersList(), this.getInventoryOrderTimeCategories(), this.getInventoryBrandList(), this.getInventoryCategoryList()]);
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  searchFn = () => this.init();
  async getSuppliersList() {
    const { data: { code, msg, data } } = await inventorySuppliers();
    if (+code === 0) {
      const { list = [] } = data;
      this.setState({ suppliersList: list });
    } else {
      message.error(msg);
    }
  }
  async getInventoryBrandList() {
    const { data: { code, msg, data } } = await inventoryBrandList();
    if (+code === 0) {
      const { list = [] } = data;
      this.setState({ brandList: list });
    } else {
      message.error(msg);
    }
  }
  async getInventoryCategoryList() {
    const { data: { code, msg, data } } = await inventoryCategoryList();
    if (+code === 0) {
      this.setState({ categoryList: data });
    } else {
      message.error(msg);
    }
  }
  getInventoryOrderTimeCategories = async () => {
    const { data: { data, msg, code } } = await inventoryOrderTimeCategories();
    if (+code === 0) {
      const { list = [] } = data;
      const categories = list.map(item => ({ category_id: item.id, category_name: item.name }));
      this.setState({ categories });
    } else {
      message.error(msg);
    }
  };
  getSuppliers = async () => {
    const { data: { code, data = [] } } = await companyTree();
    const companyId = localStorage.getItem('companyId');
    if (+code === 0) {
      const tree = formateTree(data, companyId);
      this.setState({ tree, originTree: treeToArray(data) });
    }
  }
  submitOrder = (_, confirm = false) => {
    const { selectProductInfo = {}, totalCount, todayProducts, confirmProductList } = this.state;
    if (!totalCount) {
      message.info('请先选择商品');
      return;
    }
    const keys = Reflect.ownKeys(selectProductInfo);
    const invalidList = validateMinCount(selectProductInfo, keys);
    if (invalidList.length) {
      this.setState({ invalidOrderVisible: true, invalidOrderList: invalidList });
      return;
    }
    let _confirmProductList = confirmProductList;
    const orderData = keys.filter(item => selectProductInfo[item]?.selectedRows?.length).map(item => {
      const { supplier_id = '', supplier_name = '', selectedRows = [] } = selectProductInfo[item] || {};
      // const sale_list = selectedRows.map(s => ({ ...s, number: s.warehouse_type === 'PCS' ? calcNumber(s) : s.number }));
      const sale_list = selectedRows.map((s) => {
        let _index = `${s.sale_id}-${s.sale_unit}`;
        if (todayProducts[_index]) {
          _confirmProductList = _confirmProductList.concat([todayProducts[_index]]);
        }
        return { ...s, number: calcNumber(s) };
      });
      return { supplier_id, supplier_name, sale_list };
    }, _confirmProductList);
    if (false === confirm && _confirmProductList.length > 0) {
      this.setState({
        confirmProductList: _confirmProductList
      });
      this.openRepeatProductsModal();
      return;
    }
    localStorage.setItem('orderData', JSON.stringify(orderData));
    this.props.history.push(`/basic/proposalSubmit?type=1`);
  }
  add = (record) => this.modifyProduct({ ...record, number: +record.number + 1 });
  reduce = (record) => {
    const { number } = record;
    if (number <= 0) {
      message.info('商品数量不能再减少了');
      return;
    }
    this.modifyProduct({ ...record, number: +number - 1 });
  }
  inputChanged = (e, record) => {
    const { id: currentId } = record;
    let value = e.target.value;
    const number = value;
    this.setState({ currentId, number });
  }
  onBlur = (e, record) => {
    let value = e.target.value;
    const number = +parseFloat(string2decimal(value)).toFixed(1);
    if (isNaN(number)) {
      message.info('请输入有效数字');
      return;
    }
    if (number < 0) {
      message.info('商品数量不能小于最小起订量');
      // return;
    }
    this.modifyProduct({ ...record, number: Math.max(0, number) });
  }
  modifyProduct = async record => {
    const { data: { msg, code } } = await inventoryUpdateList({ ...record });
    if (+code === 0) {
      const { number, supplier_id, id } = record;
      const { list = [], selectProductInfo = {} } = this.state;
      for (let item of list) {
        if (String(item.supplier_id) === String(supplier_id)) {
          for (let sItem of (item.sale_list || [])) {
            sItem.number = String(sItem.id) === String(id) ? Math.max(number, 0) : sItem.number;
            if (+sItem.number === 0) {
              selectProductInfo[supplier_id].selectedRows = (selectProductInfo?.[supplier_id]?.selectedRows || []).filter(item => item.number).map(item => String(item.id) === String(id) ? { ...item, number: Math.max(number, 0) } : item);
              selectProductInfo[supplier_id].selectedRowKeys = selectProductInfo[supplier_id].selectedRows.map(item => item.id);
              const current_sale_list = list.find(item => String(item.supplier_id) === String(supplier_id)).sale_list.filter(item => item.number);
              selectProductInfo[supplier_id].checked = selectProductInfo[supplier_id].selectedRowKeys.length && (current_sale_list.length === selectProductInfo[supplier_id].selectedRowKeys.length);
            }
            // break;
          }
        }
      }
      this.setState({ list: [...list], currentId: undefined, selectProductInfo }, () => {
        this.computeTotal();
      });
      this.selectRowsCache(selectProductInfo);
    } else {
      message.error(msg, 1, () => this.init());
    }
  }
  removeProductBase = async values => {
    const { data: { msg, code } } = await inventoryDeleteList({ id: values });
    if (+code === 0) {
      const { selectProductInfo = {}, list = [] } = this.state;
      const replenishTypeKeys = Object.keys(selectProductInfo) || [];
      if (values.length) {
        const newList = list.map(item => ({ ...item, sale_list: item.sale_list.filter(sItem => !values.includes(sItem.id)) })).filter(item => item.sale_list.length);
        for (let item of replenishTypeKeys) {
          const { selectedRowKeys = [], selectedRows = [] } = selectProductInfo[item];
          const newSelectedRowKeys = selectedRowKeys.filter(sItem => !values.includes(sItem));
          const newSelectedRows = selectedRows.filter(sItem => !values.includes(sItem.id));
          const currentList = newList.find(s => String(s.supplier_id) === String(item));
          const currentSaleList = currentList?.sale_list || [];
          const checked = currentSaleList.length && currentSaleList.length === newSelectedRowKeys.length;
          selectProductInfo[item] = { ...selectProductInfo[item], selectedRowKeys: newSelectedRowKeys, selectedRows: newSelectedRows, checked };
        }
        this.setState({ selectProductInfo, list: newList }, this.computeTotal);
        this.selectRowsCache(selectProductInfo);
      }
    } else {
      message.error(msg, 1, () => this.init());
    }
  }
  removeProduct = ({ id }) => this.removeProductBase([id]);
  removeProducts = () => {
    const { selectProductInfo = {}, totalCount } = this.state;
    if (totalCount) {
      const replenishTypeValues = Object.values(selectProductInfo) || [];
      const values = replenishTypeValues.reduce((acc, cur) => [...acc, ...(cur?.selectedRowKeys || [])], []);
      this.removeProductBase(values);
    }
  }
  removeProductsAll = async () => {
    const { data: { msg, code } } = await inventoryClearList();
    if (+code === 0) {
      message.success(msg);
      this.init();
    } else {
      message.error(msg);
    }
    // const { list = [] } = this.state;
    // const productIds = list.reduce((acc, cur) => ([...acc, ...(cur.sale_list || [])]), []).map(item => item.id);
    // this.removeProductBase(productIds);
  }
  clearProductsAll = async () => {
    const { data: { msg, code } } = await inventoryCartListClearNumber();
    if (+code === 0) {
      message.success(msg);
      const { list } = this.state;
      list.map((suppliers) => {
        suppliers.sale_list = suppliers.sale_list.map((item) => {
          item.number = 0;
          return item;
        });
        return suppliers;
      });
      this.setState({ list }, this.computeTotal);
      this.selectedAll({ target: { checked: false } });
    } else {
      message.error(msg);
    }
  }
  selectedAll = (e) => {
    let checked = e.target.checked;
    const { list = [], selectProductInfo } = this.state;
    if (checked) {
      for (let item of list) {
        const { supplier_id, sale_list = [] } = item;
        const filter_sale_list = sale_list.filter(item => item.can_check && (+item.number !== 0));
        const selectedRowKeys = filter_sale_list.map(item => item.id);
        const checked = filter_sale_list.length && filter_sale_list.length === selectedRowKeys.length;
        selectProductInfo[supplier_id] = { ...selectProductInfo[supplier_id], selectedRowKeys, selectedRows: filter_sale_list, checked };
      }
    } else {
      for (let item of Reflect.ownKeys(selectProductInfo)) {
        selectProductInfo[item] = { ...selectProductInfo[item], checked: false, selectedRowKeys: [], selectedRows: [] };
      }
    }
    this.setState({
      selectProductInfo,
      selectedAll: checked
    }, () => {
      this.computeTotal();
    });
    this.selectRowsCache(selectProductInfo);
  }
  computeTotal = () => {
    const { selectProductInfo = {}, list = [] } = this.state;
    const replenishTypeValues = Object.values(selectProductInfo) || [];
    const values = replenishTypeValues.reduce((acc, cur) => [...acc, ...(cur?.selectedRows || [])], []);
    const totalCount = values.length;
    const allList = list.reduce((pre, next) => [...pre, ...next.sale_list], []).filter(item => item.can_check && (+item.number !== 0));
    const selectedAll = allList.length && allList.length === values.length;
    const can_check_all = allList.length;
    const all_price = values.reduce((acc, cur) => {
      // console.log(acc, amountStrToNumber(calcItemPrice(cur)) * amountStrToNumber(cur.norms_price), '---->', acc, cur);
      return accAdd(acc, amountStrToNumber(calcNumber(cur)) * amountStrToNumber(cur.norms_price));
    }, 0);
    this.setState({ totalCount, selectedAll, can_check_all, all_price });
  }
  rowSelectionChange = (e, item, supplier_id) => {
    const { selectProductInfo = {}, list = [] } = this.state;
    const { selectedRowKeys = [], selectedRows = [] } = selectProductInfo[+supplier_id];
    let newSelectedRows = [];
    if (selectedRowKeys.includes(item.id)) {
      newSelectedRows = selectedRows.filter(c => c.id !== item.id);
    } else {
      newSelectedRows = [...selectedRows, item];
    }
    newSelectedRows = newSelectedRows.filter(item => item.can_check && (+item.number !== 0));
    const newSelectedRowKeys = newSelectedRows.map(item => item.id);
    const current = (list.find(item => String(item.supplier_id) === String(supplier_id))?.sale_list || []).filter(item => item.can_check && (+item.number !== 0));
    selectProductInfo[+supplier_id] = { ...selectProductInfo[+supplier_id], selectedRowKeys: newSelectedRowKeys, selectedRows: newSelectedRows, checked: current.length === newSelectedRowKeys.length };
    this.setState({ selectProductInfo: { ...selectProductInfo } }, this.computeTotal);
    this.selectRowsCache(selectProductInfo);
  }
  selectRowsCache(selectProductInfo) {
    localStorage.setItem('select_rows_cache', JSON.stringify(selectProductInfo));
  }
  proposalCartTitleChange = (e, supplier_id) => {
    const { selectProductInfo = {}, list = [] } = this.state;
    const { target: { checked } } = e;
    const current = (list.find(item => String(item.supplier_id) === String(supplier_id))?.sale_list || []).filter(item => item.can_check && (+item.number !== 0));
    if (checked) {
      const selectedRowKeys = current.map(item => item.id);
      selectProductInfo[supplier_id] = { ...selectProductInfo[supplier_id], selectedRowKeys, selectedRows: current, checked };
    } else {
      selectProductInfo[supplier_id] = { ...selectProductInfo[supplier_id], selectedRowKeys: [], selectedRows: [], checked };
    }
    this.setState({ selectProductInfo: { ...selectProductInfo } }, () => {
      this.computeTotal();
    });
    this.selectRowsCache(selectProductInfo);
  }
  openProductModal = () => {
    this.setState({ productModalVisible: true });
  }
  closeProductModal = () => {
    this.setState({ productModalVisible: false });
  }
  openRepeatProductsModal = () => {
    this.setState({ confirmRepeatProducts: true });
  }
  closeRepeatProductsModal = () => {
    this.setState({ confirmRepeatProducts: false, confirmProductList: [] });
  }
  closeInvalidOrderModal = () => {
    this.setState({ invalidOrderVisible: false, invalidOrderList: [] });
  }
  submitOrderConfirm = (e) => {
    this.submitOrder(e, true);
  }
  refresh = () => {
    this.init();
    this.closeProductModal();
  }

  render() {
    const { selectedAll, totalCount, emptyStatus, list = [], selectProductInfo = {}, number, currentId, loading, suppliersList = [], categoryList = [], brandList = [], confirmRepeatProducts, productModalVisible, can_check_all, all_price, token, confirmProductList = [], invalidOrderVisible, invalidOrderList = [] } = this.state;
    const empty = (<div className="cart-empty"><CpEmpty status={emptyStatus} history={this.props.history} /></div>);
    let totalSku = 0;
    for (let supplier_id in selectProductInfo) {
      for (let i = 0; i < selectProductInfo[supplier_id]['selectedRows'].length; i++) {
        totalSku = accAdd(totalSku, selectProductInfo[supplier_id]['selectedRows'][i].number);
      }
    }
    return (
      <div className="proposal-cart">
        <Row>
          <Col span={10} offset={14} style={{ textAlign: 'right', marginBottom: 10 }}>
            <Button type='primary' onClick={() => downLoad({
              url: `${ROOT_PATH}/ipp/inventory/cart-list?type=1&export=1&token=${token}`,
              name: `订货清单${moment(new Date()).format('YYYY-MM-DD')}.xlsx`
            })} disabled={!list.length}>导出</Button>
            <Button type='primary' style={{ marginLeft: 10 }} onClick={() => this.props.history.push('/basic/user/proposalCart/purchasingList')}>常购清单</Button>
            <Button type='primary' style={{ marginLeft: 10 }} onClick={this.openProductModal}>添加商品</Button>
          </Col>
        </Row>
        {loading ? <CpLoading></CpLoading> :
          <>{
            list.length <= 0 ? empty :
              <div className='purchase-cart-table'>
                <table className="cp-table cart-table">
                  <thead><tr>{(columns || []).map((item, index) => <th key={index} style={{ textAlign: item.align, width: item.width }}>{index === 0 && (<Checkbox style={{ margin: '0px 8px' }} disabled={!can_check_all} checked={selectedAll} onChange={this.selectedAll}></Checkbox>)} {item.key === 'out_norms_unit' ? <>{item.title} <Tooltip title='依据RMS订货包规计算得出，实际按订货包规进行订货'><span style={{ cursor: 'pointer' }}><QuestionCircleOutlined /></span></Tooltip></> : item.title}</th>)}</tr></thead>
                  <tbody>
                    {
                      (list || [])?.map((item, index) => {
                        const { supplier_id, supplier_name } = item;
                        return (
                          <Fragment key={index}>
                            <tr>
                              <td colSpan={columns.length} className="td-group">
                                <div className='proposal-cart-table-title'><Checkbox disabled={!(item.sale_list || []).filter(item => item.can_check && (+item.number !== 0)).length} onChange={(e) => this.proposalCartTitleChange(e, supplier_id)} checked={selectProductInfo?.[supplier_id]?.checked}></Checkbox><span style={{ paddingLeft: 26 }}>供应商：</span><span>{supplier_name}</span></div>
                              </td>
                            </tr>
                            {(item.sale_list || []).map((sItem, sIndex) => {
                              return <tr key={sIndex}>
                                {(columns || []).map((cItem, cIndex) => {
                                  const { key } = cItem;
                                  const base = ['sku_no', 'out_sku_no', 'sale_unit', 'proposal_number', 'stock', 'unit_packing', 'reference_unit_packing', 'latest_sale_cost', 'latest_cost', 'yesterday_sale_number'];
                                  if (key === 'sale_name') {
                                    const { sale_image, sale_name, purchase_time, can_check, false_reason, out_sku_no, unit_packing } = sItem;
                                    return <td key={`${supplier_id}_${cIndex}`} colSpan={2} style={{ textAlign: cItem.align, width: cItem.width }}>
                                      <div className='proposal-cart-table-product' >
                                        <div className='proposal-cart-table-product-left'><Checkbox style={{ margin: '0px 8px' }} disabled={!can_check || (+sItem.number === 0)} checked={selectProductInfo?.[supplier_id]?.selectedRowKeys?.includes(sItem.id)} onChange={e => this.rowSelectionChange(e, sItem, supplier_id)}></Checkbox></div>
                                        <img className='proposal-cart-table-product-img' src={sale_image} alt='' />
                                        <div className='proposal-cart-table-product-right' >
                                          <div>{sale_name}</div>
                                          {out_sku_no ? <div>编码：{out_sku_no}</div> : null}
                                          {unit_packing ? <div>规格：{unit_packing}</div> : null}
                                          <div>{can_check ? purchase_time : <Typography.Link>{false_reason}</Typography.Link>}</div>
                                        </div>
                                      </div>
                                    </td>;
                                  } else if (key === 'norms_price') {
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>{isNaN(sItem[key]) ? sItem[key] : `¥${currency(sItem[key])}`}/{sItem['sale_unit']}</td>;
                                  } else if (key === 'stock') {
                                    const { stock, base_stock, out_unit, sale_unit, out_prop } = sItem;
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>
                                      {stock !== '-' ? <div className='proposal-cart-table-stock' >
                                        <div>{stock} {sale_unit}</div>
                                        {out_prop > 1 ? <div>{base_stock} {out_unit}</div> : null}
                                      </div> : '-'}
                                    </td>;
                                  } else if (key === 'proposal_number') {
                                    const { proposal_number, proposal_base_number, out_unit, sale_unit, out_prop } = sItem;
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>
                                      {proposal_number !== '-' ? <div className='proposal-cart-table-stock' >
                                        <div>{proposal_number} {sale_unit}</div>
                                        {out_prop > 1 ? <div>{proposal_base_number} {out_unit}</div> : null}
                                      </div> : '-'}
                                    </td>;
                                  } else if (key === 'yesterday_purchase_number') {
                                    const { yesterday_purchase_number, out_prop, out_unit, sale_unit } = sItem;
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>
                                      {yesterday_purchase_number > 0 ? <div className='proposal-cart-table-stock' >
                                        <div>{yesterday_purchase_number} {sale_unit}</div>
                                        {out_prop > 1 ? <div>{+((yesterday_purchase_number * out_prop).toFixed(3))} {out_unit}</div> : null}
                                      </div> : '0'}
                                    </td>;
                                  } else if (key === 'latest_sale_cost') {
                                    const { latest_sale_cost, out_prop, out_unit, sale_unit } = sItem;
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>
                                      {latest_sale_cost > 0 ? <div className='proposal-cart-table-stock' >
                                        <div>￥{(latest_sale_cost * out_prop).toFixed(2)} / {sale_unit}</div>
                                        {out_prop > 1 ? <div>￥{latest_sale_cost.toFixed(2)} / {out_unit}</div> : null}
                                      </div> : '-'}
                                    </td>;
                                  } else if (key === 'latest_cost') {
                                    const { latest_cost, out_prop, out_unit, sale_unit } = sItem;
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>
                                      {latest_cost > 0 ? <div className='proposal-cart-table-stock' >
                                        <div>￥{(latest_cost * out_prop).toFixed(2)} / {sale_unit}</div>
                                        {out_prop > 1 ? <div>￥{latest_cost.toFixed(2)} / {out_unit}</div> : null}
                                      </div> : '-'}
                                    </td>;
                                  } else if (key === 'yesterday_sale_number') {
                                    const { yesterday_sale_number, out_prop, out_unit, sale_unit } = sItem;
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>
                                      {yesterday_sale_number > 0 ? <div className='proposal-cart-table-stock' >
                                        <div>{Math.ceil(yesterday_sale_number / out_prop)} {sale_unit}</div>
                                        {out_prop > 1 ? <div>{yesterday_sale_number} {out_unit}</div> : null}
                                      </div> : '-'}
                                    </td>;
                                  } else if (base.includes(key)) {
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>{sItem[key]}</td>;
                                  } else if (key === 'number') {
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width, padding: "10px" }}>
                                      <div>{sItem['min_count'] > 1 ? (`起订量：${+sItem['min_count']} ${sItem['out_unit']}`) : ''}</div>
                                      <div>{sItem['reference_factor'] > 1 ? (`参考包规：${+sItem['reference_factor']} ${sItem['out_unit']}`) : ''}</div>
                                      <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div className="countContainer">
                                          <a className="btn pointer" onClick={() => { return sItem.can_check ? this.reduce(sItem) : null; }} disabled={!sItem.can_check}>-</a>
                                          <Input className="input" defaultValue={sItem[key]} onChange={(e) => { this.inputChanged(e, sItem); }} value={currentId === sItem.id ? number : sItem[key]} onBlur={(e) => { this.onBlur(e, sItem); }} onPressEnter={(e) => { this.onBlur(e, sItem); }} disabled={!sItem.can_check} />
                                          <a className="btn pointer" onClick={() => { return sItem.can_check ? this.add(sItem) : null; }} disabled={!sItem.can_check}>+</a>
                                        </div>
                                        {sItem.sale_unit}
                                      </div>
                                      <div className='proposal-cart-table-number' >
                                        {
                                          // sItem[key] > 0 ? <span>{+(sItem[key] * sItem.out_prop)} {sItem.out_unit}</span> : null
                                          sItem.out_prop > 1 ? <span>{+(sItem[key] * sItem.out_prop).toFixed(3)} {sItem.out_unit}</span> : null
                                        }
                                      </div>
                                    </td>;
                                  } else if (key === 'arrival_type') {
                                    // return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>¥{currency(sItem.warehouse_type === 'PCS' ? amountStrToNumber(calcItemPrice(sItem)) : amountStrToNumber(calcItemPrice(sItem)) * amountStrToNumber(sItem.norms_price))}</td>;
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>{arrival_type_config[`${sItem.arrival_type}`]}</td>;
                                  } else if (key === 'item_price') {
                                    // return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>¥{currency(sItem.warehouse_type === 'PCS' ? amountStrToNumber(calcItemPrice(sItem)) : amountStrToNumber(calcItemPrice(sItem)) * amountStrToNumber(sItem.norms_price))}</td>;
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>¥{currency(amountStrToNumber(calcItemPrice(sItem)))}</td>;
                                  }
                                  //  else if (key === 'norms_price') {
                                  //   return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>{sItem.can_check ? sItem[key] : <Typography.Link style={{ fontSize: 12 }}>{sItem?.false_reason}</Typography.Link>}</td>;
                                  // }
                                  else if (key === 'real_number') {
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>{calcNumber(sItem)}</td>;
                                  }
                                  else if (key === 'out_norms_unit') {
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>{calcOutNormsUnit(sItem)}</td>;
                                  }
                                  else if (key === 'out_norms_unit') {
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>{`${sItem.out_norms_prop}${sItem.out_unit} / ${sItem.out_norms_unit}`}</td>;
                                  } else if (key === 'operation') {
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}><Popconfirm title="确定要删除商品吗?" onConfirm={() => this.removeProduct(sItem)} okText="确认" cancelText="取消"><Button type='link' className='pointer'>删除</Button></Popconfirm></td>;
                                  } else {
                                    return null;
                                  }
                                })}
                              </tr>;
                            })}
                          </Fragment>
                        );
                      })
                    }
                  </tbody>
                </table>
                <div className="whitespace"></div>
                <div className={true ? 'bottom fixed-bottom' : 'bottom'}>
                  <div className="bottom-content">
                    <div className="bottom-left">
                      <div className="bottom-select-all"><Checkbox style={{ margin: '0px 8px' }} disabled={!can_check_all} checked={selectedAll} onChange={(e) => { this.selectedAll(e); }}></Checkbox>全选</div>
                      <div className="bottom-delete-select">
                        <span className='pointer' onClick={() => { this.removeProducts(); }}>删除所选商品</span>
                        <Popconfirm
                          title="是否确定删除购物车?"
                          okText="确定"
                          cancelText="取消"
                          onConfirm={this.removeProductsAll}
                        >
                          <span className='pointer' style={{ marginLeft: 20 }}>清空购物车</span>
                        </Popconfirm>
                        <Popconfirm
                          title="清空所有商品数量?"
                          okText="确定"
                          cancelText="取消"
                          onConfirm={this.clearProductsAll}
                        >
                          <span className='pointer' style={{ marginLeft: 20 }}>清空数量</span>
                        </Popconfirm>
                      </div>
                    </div>
                    <div className="bottom-right">
                      <div className="bottom-select-count">已选择<span className="bottom-select-count-value">{totalCount}</span>种（<span className="bottom-select-count-value">{totalSku}</span>）件商品</div>
                      <div className="bottom-select-count" style={{ display: 'none' }}><span className="bottom-select-count-value">总价：¥{currency(all_price)}</span></div>
                      <Button className="bottom-submit-settlement" disabled={!totalCount} type='primary' style={!totalCount ? { backgroundColor: '#979797' } : {}} onClick={this.submitOrder}>提交订货单</Button>
                    </div>
                  </div>
                </div>
              </div>
          }
          </>
        }
        <Modal title='商品清单' open={productModalVisible} destroyOnClose width={1200} centered onCancel={this.closeProductModal} getContainer={false} footer={false} >
          <PurchaseCartProduct {...{ suppliersList, categoryList, brandList, refresh: this.refresh, type: 'cart' }} />
        </Modal>
        <Modal title='以下商品今日已订货，请确认' open={confirmRepeatProducts} destroyOnClose width={600} centered onCancel={this.closeRepeatProductsModal} onOk={this.submitOrderConfirm} okText={'确认订货'} getContainer={false} >
          {confirmProductList.map(item => (<p key={item._index}>{item.out_sku_no}：{item.sale_name} 今日已订货 {item.number}{item.sale_unit}</p>))}
        </Modal>
        <Modal title={<span><ExclamationCircleOutlined style={{ color: '#ff4d4f', marginRight: 8 }} />起订量校验未通过</span>} open={invalidOrderVisible} destroyOnClose width={600} centered onCancel={this.closeInvalidOrderModal} maskClosable={false} footer={null} getContainer={false} >
          <div style={{ maxHeight: 400, overflowY: 'auto', whiteSpace: 'pre-line' }}>
            {invalidOrderList.join('\n')}
          </div>
        </Modal>
      </div>
    );
  }
}
export default withRouter(ProposalCart);